import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentWithoutEdit } from "../../../Common/Table/tableContent";

export default class ComponentToPrint extends React.Component {
  render() {
    const searchData = this.props.searchData;
    const data = this.props.data;
    const contentRowNames = this.props.rowNames;

    return (
      <div>
        <h3>
          <center>
            <u>Daily Check Role Summary Report</u>
          </center>
        </h3>
        <div className="row pl-2 pb-4 pt-4">
          <div className="col">
            <b>Group: </b> {searchData.group}
          </div>
          <div className="col">
            <b>Estate: </b> {searchData.estate}
          </div>
          <div className="col">
            <b>Division: </b> {searchData.division}
          </div>
          <div className="col">
            <b>Plucking Type: </b> {searchData.pluckingType}
          </div>
          <div className="col">
            <b>Date: </b> {searchData.date}
          </div>
        </div>
        <div className="col width4">
          <table className="display dataTable no-footer">
            <thead>
              <tr>
                <th>EPF Number</th>
                <th>Registration Number</th>
                <th>Emp Name</th>
                <th>Field Name</th>
                <th>Check Role Total</th>
                <th>Extra Kg</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {data != null || data.length != 0
                ? data.map((item) => (
                    <>
                      {item.reportList.map((detail, index) => (
                        <tr>
                          {index == 0 ? (
                            <>
                              <td rowSpan={item.reportList.length}>
                                {item.epfNo}
                              </td>
                              <td rowSpan={item.reportList.length}>
                                {item.registrationNumber}
                              </td>
                              <td rowSpan={item.reportList.length}>
                                {item.empName}
                              </td>
                            </>
                          ) : null}
                          <td> {detail.fieldName}</td>
                          <td>{detail.checkRoleTotal}</td>
                          <td>{detail.extraKg}</td>
                          {index == 0 ? (
                            <td rowSpan={item.reportList.length}>
                              {item.allTotal}
                            </td>
                          ) : null}
                        </tr>
                      ))}
                    </>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
